export default {"src":"/_next/static/media/Parate.3a866504.svg","height":42,"width":43};